import gql from 'graphql-tag'
import { EnumFields } from '..'

// TODO: include [icon, color] when available
export const PersonActivityTypeFragment = gql`
  fragment PersonActivityType on persons_activity_type {
    ${EnumFields}
  }
`
